module.exports = __webpack_public_path__ + "img/user-avatar-placeholder.4a44b98e.png";